const locationSVG = (color = '#888888') => `
<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
        d="M6.09791 8C4.97787 8 4.06616 7.05167 4.06616 5.96721C4.06616 4.88275 4.97787 4 6.09791 4C7.21794 4 8.12965 4.88275 8.12965 5.96721C8.12965 7.05167 7.21794 8 6.09791 8Z" 
        stroke="${color}" 
        stroke-width="1.5" 
        stroke-miterlimit="10" 
        stroke-linejoin="round"
    />
    <path 
        d="M10.1936 8.658C10.7037 7.88658 11 6.91095 11 5.92187C11 3.20363 8.76144 1 6 1C3.23856 1 1 3.20363 1 5.92187C1 6.91095 1.29633 7.88658 1.8065 8.658L6 15L8.82851 10.7224" 
        stroke="${color}" 
        stroke-width="1.5" 
        stroke-miterlimit="10" 
        stroke-linecap="round" 
        stroke-linejoin="round"
    />
</svg>
`

export default locationSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/locationSVG.js